export enum ERROR {
    IS_REQUIRED = 'IS_REQUIRED',
    NOT_POSITIVE = 'NOT_POSITIVE',
}
